module.exports = __webpack_public_path__ + "img/Bco-Congresos_blanco.435bd17e.png";